// extracted by mini-css-extract-plugin
export default {"stories":"StoryList_stories__Dfe7u","stories__loader":"StoryList_stories__loader__M50Sy"};